import { Link } from 'react-router-dom';
import EnrolleeFileUpload from './EnrolleeFileUpload';
import MemberSearch from './MemberSearch';

const EligibleEnrollees = () => {
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/admin-panel" className="link">
							Admin Panel
						</Link>
					</li>
					<li>Eligible Enrollees</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<MemberSearch />
				<div className="divider" />
				<EnrolleeFileUpload />
			</div>
		</>
	);
};

export default EligibleEnrollees;
